import { ArrowBack } from "@material-ui/icons";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import axios from "axios";
import { CustomTable, ModalError, SearchTextInput } from "components";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { getErrors } from "utils";
import { columnTable } from "../Constants";

export const ModalCostAllocationSummary = ({
  open,
  onClose,
  title,
  params,
  filter,
}) => {
  const history = useHistory();
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const apiURL = "publisher/transaction/v2/cost-allocation";

  const [loadingPage, setLoadingPage] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [queryParams, setQueryParams] = useState({
    page: 1,
    size: 10,
    search: "",
    year: params?.year,
    composer_ids: params?.composer_id,
    status: filter === "total" ? "" : filter,
  });
  const [tableTotalPage, setTableTotalPage] = useState(1);

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
  };

  const getDataTable = async () => {
    try {
      setLoadingPage(true);
      const res = await axios.get(`${hardBaseUrl}/${apiURL}`, {
        headers,
        params: Object.fromEntries(
          Object.entries(queryParams).filter(
            ([, v]) => v !== "" && v !== null && v !== undefined
          )
        ),
      });
      const { data, meta, total_page } = res?.data;
      setDataTable(data || []);
      const calculatedPages =
        meta?.total && meta?.limit ? Math.ceil(meta.total / meta.limit) : 1;
      setTableTotalPage(total_page || meta?.last_page || calculatedPages);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  const debounceDataTable = useCallback(
    debounce(() => {
      getDataTable();
    }, 500),
    [queryParams]
  );

  useEffect(() => {
    const isSearching = Boolean(queryParams?.search);
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [queryParams, debounceDataTable]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={true}
    >
      <DialogTitle>
        <Grid container alignItems="center" columnGap={1}>
          <Grid item>
            <IconButton onClick={onClose}>
              <ArrowBack />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography fontSize={24} fontWeight={700}>
              {title}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <SearchTextInput
          fullWidth
          placeholder="Search Document"
          value={queryParams?.search}
          onChange={e => {
            handleChangeQueryParams(e?.target?.value, "search");
          }}
        />
        <Box mt="24px">
          <CustomTable
            columnTable={columnTable}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.size}
            pageCount={tableTotalPage}
            handleChangePage={(_, page) =>
              handleChangeQueryParams(page, "page")
            }
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "size")
            }
            isLoading={loadingPage}
            maxHeight={400}
            isHaveAction
            handleView={item =>
              history.push(
                `/admin/detail-cost-allocation/${item?.cost_allocation_id}`
              )
            }
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};
